module.exports = __webpack_public_path__ + "img/left_5.a4d57c43.jpg";